import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { Session } from 'models';

import styles from './styles';
import ChatHistoryItem from '../ChatHistoryItem';

export default class ChatHistoryList extends PureComponent {
  renderList() {
    const { sessions } = this.props;

    return sessions.map(chat => {
      return <ChatHistoryItem key={chat.get('id')} item={chat} />;
    });
  }
  render() {
    return (
      <div role="tree" style={styles.alley} className="kustomer-app-list">
        {this.renderList()}
      </div>
    );
  }
}

ChatHistoryList.propTypes = {
  sessions: ImmutablePropTypes.orderedSetOf(PropTypes.instanceOf(Session)),
};

ChatHistoryList.defaultProps = {
  sessions: Immutable.OrderedSet(),
};
